import { Delete } from "@mui/icons-material"
import { IconButton } from "@mui/material"

export default function IconButtonDelete({
  onClick,
  disabled = false,
  ...props
}: {
  onClick: () => void
  disabled?: boolean
}) {
  return (
    <IconButton
      size="small"
      disabled={disabled}
      onClick={onClick}
      sx={{
        "&:hover": {
          color: "error.dark",
        },
      }}
      aria-label="delete"
      {...props}
    >
      <Delete />
    </IconButton>
  )
}
